import {
	updateWizardStepOnPrevNext,
	updateWizardStepOnWizardItem,
} from 'src/components/Lists/list-helpers';
import { clearIncompatibleSelection } from './settings_config_helpers';
import type { wizardItem } from 'src/types/WizardItemType';
import type { Selection } from 'src/types/Device';

export const onClickWizardItem = (
	e: MouseEvent,
	index: number,
	wizardItems: wizardItem[],
	activeStep: wizardItem,
	selected: Selection,
) => {
	const result = updateWizardStepOnWizardItem(index, wizardItems, activeStep);

	clearIncompatibleSelection(result.activeWizardStep.activeIndex, selected);

	return result;
};

export const onClickPrevNextButton = (
	type: 'prev' | 'next',
	wizardItems: wizardItem[],
	activeStep: wizardItem,
	selected: Selection,
) => {
	const result = updateWizardStepOnPrevNext(type, wizardItems, activeStep);

	clearIncompatibleSelection(result.activeWizardStep.activeIndex, selected);

	return result;
};

export const handleNextOrApply = (
	isLastStepWizard: boolean,
	activeStep: wizardItem,
	selected: Selection,
	wizardItems: wizardItem[],
	handleApply,
	WIZARD_STEPS: { [key: string]: number },
) => {
	const shouldApplyImmediately =
		isLastStepWizard ||
		(activeStep.activeIndex === WIZARD_STEPS.DEVICE_SELECTION &&
			selected.id &&
			selected.type === 'device');

	if (shouldApplyImmediately) {
		handleApply();
		return null;
	} else {
		return onClickPrevNextButton('next', wizardItems, activeStep, selected);
	}
};

export const handleDeviceSelection = (e: CustomEvent, selected: Selection): Selection => {
	const deviceId = e.detail.id;
	return selected.type === 'device' && selected.id === deviceId
		? { id: '', type: '' as const }
		: { id: deviceId, type: 'device' as const };
};
